/**
 * 儿童平板路由
 * */
export default [
  {
    path: "/tabletIndex",
    name: "tabletIndex",
    meta: {
      title: '首页'
    },
    component: () => import("@/views/TabletSystem/index")
  },{
    path: '/tabletChannelList',
    name: 'tabletChannelList',
    component: () => import('@/views/TabletSystem/deviceManage/channelList'),
    meta: {
      title: '渠道管理'
    }
  },{
    path: '/tabletMachineList',
    name: 'tabletMachineList',
    component: () => import('@/views/TabletSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },{
    path: '/tabletDeviceList',
    name: 'tabletDeviceList',
    component: () => import('@/views/TabletSystem/deviceManage/deviceList'),
    meta: {
      title: '设备管理'
    }
  },{
    path: '/tabletUserList',
    name: 'tabletUserList',
    component: () => import('@/views/TabletSystem/baby/babyUserList'),
    meta: {
      title: '用户管理'
    }
  },{
    path: '/tabletOtaManger',
    name: 'tabletOtaManger',
    component: () => import('@/views/TabletSystem/apply/otaManger'),
    meta: {
      title: 'OTA管理'
    }
  },{
    path: '/tabletAppManager',
    name: 'tabletAppManager',
    component: () => import('@/views/TabletSystem/apply/appManager'),
    meta: {
      title: 'APP管理'
    }
  },{
    path: '/tabletOtaDownloadLogs',
    name: 'tabletOtaDownloadLogs',
    component: () => import('@/views/TabletSystem/apply/otaDownloadLogs'),
    meta: {
      title: 'OTA升级记录'
    }
  },{
    path: '/tabletDeviceAppExclude',
    name: 'tabletDeviceAppExclude',
    component: () => import('@/views/TabletSystem/apply/deviceAppExclude'),
    meta: {
      title: 'APP黑名单'
    }
  },{
    path: '/tabletDeviceInstruction',
    name: 'tabletDeviceInstruction',
    component: () => import('@/views/TabletSystem/deviceManage/deviceInstruction'),
    meta: {
      title: '设备指令'
    }
  },{
    path: '/tabletImeiErrorLogList',
    name: 'tabletImeiErrorLogList',
    component: () => import('@/views/TabletSystem/deviceManage/imeiErrorLogList'),
    meta: {
      title: '设备日志'
    }
  },{
    path: '/tabletAddModelPage',
    name: 'tabletAddModelPage',
    meta: {
      title: '新增机型'
    },
    component: () => import('@/views/TabletSystem/deviceManage/addModelPage')
  },{
    path: '/tabletEditModelPage',
    name: 'tabletEditModelPage',
    meta: {
      title: '编辑机型'
    },
    component: () => import('@/views/TabletSystem/deviceManage/editModelPage')
  },{
    path: '/tabletDeviceMonthRegister',
    name: 'tabletDeviceMonthRegister',
    meta: {
      title: '设备统计'
    },
    component: () => import('@/views/TabletSystem/bi/deviceMonthRegister')
  },{
    path: '/tabletUserMonthRegister',
    name: 'tabletUserMonthRegister',
    meta: {
      title: '用户统计'
    },
    component: () => import('@/views/TabletSystem/bi/userMonthRegister')
  },{
    path: '/tabletOtaUpdateAddPage',
    name: 'tabletOtaUpdateAddPage',
    meta: {
      title: 'OTA新增'
    },
    component: () => import('@/views/TabletSystem/apply/otaUpdateAddPage')
  },{
    path: '/tabletOtaUpdateEditPage',
    name: 'tabletOtaUpdateEditPage',
    meta: {
      title: 'OTA编辑'
    },
    component: () => import('@/views/TabletSystem/apply/otaUpdateEditPage')
  },{
    path: '/tabletAppUpdateAddPage',
    name: 'tabletAppUpdateAddPage',
    meta: {
      title: 'App新增'
    },
    component: () => import('@/views/TabletSystem/apply/appUpdateAddPage')
  },{
    path: '/tabletAppUpdateEditPage',
    name: 'tabletAppUpdateEditPage',
    meta: {
      title: 'App编辑'
    },
    component: () => import('@/views/TabletSystem/apply/appUpdateEditPage')
  },{
    path: '/tabletApkUpdateAddPage',
    name: 'tabletApkUpdateAddPage',
    meta: {
      title: 'Apk新增'
    },
    component: () => import('@/views/TabletSystem/apply/apkUpdateAddPage')
  },{
    path: '/tabletApkUpdateEditPage',
    name: 'tabletApkUpdateEditPage',
    meta: {
      title: 'Apk编辑'
    },
    component: () => import('@/views/TabletSystem/apply/apkUpdateEditPage')
  },{
    path: '/tabletApkManager',
    name: 'tabletApkManager',
    meta: {
      title: 'APK管理'
    },
    component: () => import('@/views/TabletSystem/apply/apkManager')
  },{
    path: '/tabletDeviceQualityAssessment',
    name: 'tabletDeviceQualityAssessment',
    meta: {
      title: '智能检测'
    },
    component: () => import('@/views/TabletSystem/deviceManage/deviceQualityAssessment')
  },{
    path: '/tabletDeviceAuthList',
    name: 'tabletDeviceAuthList',
    component: () => import('@/views/TabletSystem/deviceManage/deviceAuthList'),
    meta: {
      title: '设备授权'
    },
  },{
    path: '/tabletActivateList',
    name: 'tabletActivateList',
    component: () => import('@/views/TabletSystem/deviceManage/activateList'),
    meta: {
      title: '设备激活列表'
    },
  },{
    path: '/tabletDeviceLogView',
    name: 'tabletDeviceLogView',
    component: () => import('@/views/TabletSystem/baby/deviceLogView'),
    meta: {
      title: '设备日志'
    },
  },{
    path: '/tabletSearchAppUse',
    name: 'tabletSearchAppUse',
    component: () => import('@/views/TabletSystem/bi/searchAppUse'),
    meta: {
      title: 'APP应用使用情况'
    },
  },{
    path: '/tabletChannelAppPage',
    name: 'tabletChannelAppPage',
    component: () => import('@/views/TabletSystem/deviceManage/ChannelAppPage'),
    meta: {
      title: '渠道APP关系管理'
    },
  },{
    path: '/tabletCheckModel',
    name: 'tabletCheckModel',
    component: () => import('@/views/TabletSystem/deviceManage/checkModel'),
    meta: {
      title: '查看机型'
    },
  }, {
    path: '/tabletKiDozApp',
    name: 'tabletKiDozApp',
    component: () => import("@/views/TabletSystem/bi/KiDozApp"),
    meta: {
      title: 'kiDozApp'
    }
  }, {
    path: '/tabletKiDoz',
    name: 'tabletKiDoz',
    component: () => import("@/views/TabletSystem/bi/tabletKiDoz"),
    meta: {
      title: 'KiDoz详情'
    }
  }, {
    path: '/tabletVirtualSnBatchList',
    name: 'tabletVirtualSnBatchList',
    component: () => import("@/views/TabletSystem/deviceManage/virtualSnBatchList"),
    meta: {
      title: '授权批次'
    }
  }, {
    path: '/tabletVirtualSnLicenseList',
    name: 'tabletVirtualSnLicenseList',
    component: () => import("@/views/TabletSystem/deviceManage/virtualSnLicenseList"),
    meta: {
      title: '授权许可'
    }
  },{
    path: '/tabletOtaUpgrade',
    name: 'OtaUpgrade',
    meta: {
      title: 'OTA升级统计'
    },
    component: () => import('@/views/publicView/bi/OtaUpgrade')
  }
]



// WEBPACK FOOTER //
// ./src/router/tabletRouter.js